import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Nav } from "./Nav";
import { useNavigate } from 'react-router-dom';
import { verifyToken, logout as logoutUrl, logoutAllDevices } from '../utils/urls';
import jwt_decode from "jwt-decode";
import axios from '../utils/axios';
import { RefreshToken } from '../utils/refreshToken';
import { clearSession } from '../utils/session';
import useIdleTimeout from './useIdleTimeout';
import Swal from 'sweetalert2';
import FloatingTicketButton from './FloatingTicketButton';
import { ConfirmDialog } from './ConfirmModal';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from '../utils/userSlice';
import useAppActivitySocket from '../components/apps/workingOn/useAppActivitySocket';
import { useSelector } from 'react-redux';

const Layout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locationId } = useParams();
  const userId = useSelector(state => state.user.userId);
  const isSuperuser = useSelector((state) => state.user.isSuperuser);
  const image = useSelector((state) => state.user.image);
  const userLable = useSelector((state) => state.user.userLable);
  const userName = useSelector((state) => state.user.userName);
  const is_leader = useSelector((state) => state.user.is_leader);
  const [scrolling, setScrolling] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useAppActivitySocket(!!userId);

  // Idle-session watchdog: warns before the server idle window expires and logs
  // out on inactivity. Also keeps an active-but-no-API user alive via keep-alive.
  useIdleTimeout();

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const authTokens = JSON.parse(localStorage.getItem('authTokens'));
    const refresh = authTokens?.refresh;
    if (refresh) {
      const body = JSON.stringify({ token: refresh });
      axios
        .post(verifyToken, body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          if (response.status === 200) {
            const access = authTokens?.access;
            const decodedToken = jwt_decode(access);
            // console.log('decodedToken:', decodedToken); 
            let activePipeline = localStorage.getItem("activePipeline")
            let appPipeline = localStorage.getItem("appPipeline")
            let defaultLanguage = localStorage.getItem("defaultLanguage")
            dispatch(setUser({
              userId: decodedToken.user_id,
              isSuperuser: decodedToken.is_superuser,
              userLable: decodedToken.userLable,
              image: decodedToken.image,
              userName: decodedToken.userName,
              firstName: decodedToken.firstName,
              lastName: decodedToken.lastName,
              ghlUserId: decodedToken.ghlUserId,
              is_leader: decodedToken.is_leader,
              designation: decodedToken?.designation || "",
              activePipeline: activePipeline || "",
              appPipeline: appPipeline || "",
              defaultLanguage: defaultLanguage || "",
              bizCardUrl: decodedToken.biz_card_url || null,
              locationCardUrl: decodedToken.location_card_url || null,
              languages: decodedToken.languages || [],
            }));
            localStorage.setItem("prevUrl", window.location.pathname);
            // if (!decodedToken.is_superuser) {
            //   navigate('/');
            // }
          }
        })
        .catch((err) => {
          console.error('Token verification failed:', err);
          localStorage.removeItem('authTokens');
          localStorage.removeItem('prevUrl');
          dispatch(setUser({ userId: null, isSuperuser: null, userLable: null, image: null, userName: null, firstName: null, lastName: null, ghlUserId: null, is_leader: null, designation: "", activePipeline: "", appPipeline: "", defaultLanguage: "" }));
          navigate('/login');
        })
        .finally(() => setIsLoading(false));
    } else {
      localStorage.removeItem('authTokens');
      localStorage.removeItem('prevUrl');
      dispatch(setUser({ userId: null, isSuperuser: null, userLable: null, image: null, userName: null, firstName: null, lastName: null, ghlUserId: null, is_leader: null, designation: "", activePipeline: "", appPipeline: "", defaultLanguage: "" }));
      navigate('/login');
      setIsLoading(false);
    }
  }, []);

  // useEffect(() => {
  //   const intervalId = setInterval(async () => {
  //     await RefreshToken();
  //   }, 3600000);
  //   return () => clearInterval(intervalId);
  // }, []);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure to log out?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {
          await axios.post(logoutUrl);
        } catch (err) {
          console.error('Logout API failed', err);
        }
        clearSession();
        dispatch(setUser({
          userId: null,
          isSuperuser: null,
          userLable: null,
          image: null,
          userName: null,
          ghlUserId: null,
          is_leader: null,
          designation: ""
        }));
        navigate('/login');
      }
    });
  };

  const handleLogoutAll = () => {
    Swal.fire({
      title: 'Log out of all devices?',
      text: 'This signs you out everywhere, including this device.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, log out everywhere',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post(logoutAllDevices);
        } catch (err) {
          console.error('Logout-all API failed', err);
        }
        clearSession();
        dispatch(setUser({
          userId: null,
          isSuperuser: null,
          userLable: null,
          image: null,
          userName: null,
          ghlUserId: null,
          is_leader: null,
          designation: ""
        }));
        navigate('/login');
      }
    });
  };


  return (
    <div style={{ minHeight: "100vh", margin: 0, background: "black" }}>
      <header className={`${scrolling ? 'sticky' : ''}`}>
        <Nav handleLogout={handleLogout} handleLogoutAll={handleLogoutAll} isSuperuser={isSuperuser} userId={userId} userLable={userLable} image={image} userName={userName} is_leader={is_leader} />
      </header>
      {/* <header className={`${scrolling ? 'sticky' : ''} mobileview_home`}>
        <Nav handleLogout={handleLogout} handleLogoutAll={handleLogoutAll} isSuperuser={isSuperuser} userId={userId} userLable={userLable} image={image} userName={userName} is_leader={is_leader} />
      </header> */}
      <main>
        <Outlet />
      </main>
      <FloatingTicketButton />
      <ConfirmDialog />
    </div>
  );
};

export default Layout;